import React from "react";
import SvgIcon from "../../../SvgIcon/SvgIcon";
import {iIcon} from "../../../../shared/interfaces";

const PermissionDeviceTile = ({ name, timezone, color, icon }: {name: string; timezone: string; color: string; icon: iIcon}) => {
    return (
        <div className="permission-report-device-card">
            <SvgIcon
                color={color}
                icon={icon}
                size='sm'
            />
            <div>
                <div className="permission-report-device-name">{name}</div>
                <div className="permission-report-device-timezone">{timezone}</div>
            </div>
        </div>
    );
};

export default PermissionDeviceTile;